import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Angulartics2 } from 'angulartics2';

import Munchkin from './munchkin';

interface AnalyticsEvent {
    action: string;
    properties: any;
}

@Injectable()
export class Angulartics2Marketo {

    constructor(private _angulartics2: Angulartics2) {

        this._angulartics2.pageTrack.subscribe(event => this._pageTrack(event));
        this._angulartics2.eventTrack.subscribe(event => this._eventTrack(<AnalyticsEvent>event));
        this._angulartics2.setUsername.subscribe((x: string) => this._setUsername(x));
    }

    private _pageTrack({ path }: { path?: string }) {
        Munchkin.visitWebPage(path);
    }

    private _eventTrack({ action, properties }: AnalyticsEvent) {
        properties = Object.assign({}, properties);
        const path = properties.path;
        delete properties.path;

        const params = new URLSearchParams();
        for (const key of Object.keys(properties)) {
            const value = properties[key];
            params.set(key, value);
        }

        if (properties.label === 'visit') {
            Munchkin.visitWebPage(action, params.toString());
        }

        if (properties.eventType === 'click') {
            Munchkin.clickLink(action, params.toString());
        } else {
            Munchkin.visitWebPage(path, params.toString());
        }
    }
    private _setUsername(email: string) {
        if (email === null) {
            Munchkin.logout();
        }
    }
}
